import React from 'react';
import clsx from 'clsx';
import { db } from 'src/firebase';
import {collection, query, getDocs, deleteDoc, doc, where} from 'firebase/firestore';
import Layout from 'src/layouts/Default';
import { Button, Card, Heading, Icon, Spinner, Text, TextInput, TickCircleIcon } from 'evergreen-ui';

const Unsubscribe = () => {

    const [isUnsunscribing, setIsUnsubscribing] = React.useState(false);
    const [isComplete, setIsComplete] = React.useState(false);
    const [_email, setEmail] = React.useState('');
    const [isEmailValid, setIsEmailValid] = React.useState(false);

    const onEmailChange = (e) => {
        setIsEmailValid(e.target.validity.valid);
        setEmail(e.target.value);
    }

    const onUnsubscribe = async () => {
        if (!isEmailValid)
            return;

        setIsUnsubscribing(true);
        
        const subscriber = query(collection(db,"subscribers"), where("email", "==", _email));
        
        
        const querySnapshot = await getDocs(subscriber);
        querySnapshot.forEach(async item =>{
            const docRef = doc(db, "subscribers", item.id);
            await deleteDoc(docRef);
        })

        setTimeout(() => {
            setIsUnsubscribing(false);
            setIsComplete(true);
        }, 850);

        setTimeout(() => {
            setEmail('');
            setIsComplete(false);
        }, 4000);
    };

    return (
        <Layout>
            <Card className={clsx('subscribe', isUnsunscribing && 'subscribe--loading', isComplete && 'subscribe--complete')} elevation={4} padding="30px" borderRadius="8px">
                {!isUnsunscribing && <Heading marginBottom="8px">Enter your email</Heading>}
                {isUnsunscribing && 'subscribe--loading' && <Text>Unsubscribing...</Text>}
                <form onSubmit={e => e.preventDefault()}>
                    <TextInput marginBottom="12px" required id="email" type="email" placeholder="Email Address" value={_email} onChange={onEmailChange} />
                    <Button width="100%" onClick={onUnsubscribe}>Unsubscribe</Button>
                </form>
                {isUnsunscribing && <div className="loading">
                    <Spinner />
                </div>}
                {isComplete && <Text>Unsubscribed <Icon icon={TickCircleIcon}/></Text>}
            </Card>
        </Layout>
    );
};

export default Unsubscribe;
